/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
export const DepositeTypeColumnFormatter = (cellContent, row, rowIndex) => {
  const { deposite_type } = row;
  const { name = "" } = deposite_type || {};

  const renderStatus = (status) => {
    let statusClass = "";
    statusClass =
      status && status === "Debit card"
        ? "depositeType-debitCard"
        : status && status === "Credit Card"
        ? "depositeType-credit"
        : status && status === "Wire Transfer"
        ? "depositeType-wire-transfer"
        : status && status === "ACH"
        ? "depositeType-ach"
        : status && status === "eCheck"
        ? "depositeType-eCheck"
        : status && status === "General"
        ? "depositeType-general"
        : "depositeType-general";
    return (
      <>
        <div className="row">
          <li className={`${statusClass}`}></li>
          {status ? status : "-"}
        </div>
      </>
    );
  };

  return (
    <div>
      {renderStatus(name)}
      {name.length === 0 && "-"}
    </div>
  );
};
